/* 
0. intention correction	
1. algolia_analytics.js	
2. algolia_translations.js		
3. algolia_helpers.js
4. algolia_autocomplete.js
5. algolia_facets.js
6. algolia_sort_orders.js
7. algolia_instant_search.js
*/
/* #0. */
function intentionCorrection(queryInp){
  var reQueryString = '';
  if(typeof queryInp !== undefined){
    reQueryString = '';
    var reQueryPush = [];
    var reQueryArr = queryInp.split(' ');
    reQueryArr.forEach(function(reQueryPart) {
      /// FIND INTENTION ///
      var reQueryPartOrig = reQueryPart;
      if(reQueryPartOrig.indexOf('%') > -1){
        // composition = exact search
        reQueryPartOrig = '"' + reQueryPartOrig + '"';
      }
      reQueryPush.push(reQueryPartOrig);
      var reQueryFirst = reQueryPart.charAt(0);
      var reQueryLng = reQueryPart.length;
      // numeric search 3 or more numbers //
      if(!isNaN(reQueryFirst) && reQueryLng > 2){
        reQueryPartClean = reQueryPart.replace('-', '/');
        reQueryPartSkuMain = reQueryPartClean;
        reQueryPartSkuColor = '';
        if(reQueryPartClean.indexOf('/') > -1){
          reQueryPartSkuArr = reQueryPartClean.split('/');
          reQueryPartSkuMain = reQueryPartSkuArr[0];
          reQueryPartSkuColor = '/' + reQueryPartSkuArr[1];
        }
        reQueryPartSkuMainLng = reQueryPartSkuMain.length;
        // main article lng prefixer //
        if(reQueryPartSkuMainLng == 3){
          reQueryPush.push('or 00' + reQueryPartSkuMain + reQueryPartSkuColor);
          reQueryPush.push('or 0' + reQueryPartSkuMain + reQueryPartSkuColor);
        } else if(reQueryPartSkuMainLng == 4){
          reQueryPush.push('or 0' + reQueryPartSkuMain + reQueryPartSkuColor);
        } else if(reQueryPartSkuMainLng == 8){
          var reQuerySplit1 = reQueryPartSkuMain.slice(0, 5);
          var reQuerySplit2 = reQueryPartSkuMain.slice(5);
          reQueryPush.push('or ' + reQuerySplit1 + '/' + reQuerySplit2);
        }
      }
    });
    reQueryString = reQueryPush.join(' ');
  }
  return reQueryString;
}
/* #1. */
(function (algolia) {
  'use strict';
  var enabled = algolia.config.analytics_enabled;
  if (!enabled) return;
    var ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@2.0.3";
    !function(e,a,t,n,s,i,c){
        e.AlgoliaAnalyticsObject=s,e[s]=e[s]||function(){
            (e[s].queue=e[s].queue||[]).push(arguments)
        },i=a.createElement(t),c=a.getElementsByTagName(t)[0], i.async=1,i.src=n,c.parentNode.insertBefore(i,c)
    }(window,document,"script",ALGOLIA_INSIGHTS_SRC,"aa");
  
    window.aa('init', {
      appId: algolia.config.app_id,
      apiKey: algolia.config.search_api_key
    })
}(algoliaShopify));

/* #2. */
(function (algolia) {
  'use strict';
    var algolocal = {
      en: {
        yes: "Yes",
		no: "No",
        weight: "Weight",
        composition: "Composition",
        certificates: "Certificates",
        swatch: "Color",
        search: "Current search",
        noCollectionFound: "No collection found",
        allProducts: "See all products",
        matching: "matching",
        sortBy: "Sort by",
        relevance: "Art.Nr. (all colors)",
        resultsFound: "results found",
        oneResultFound: "1 result found",
        noResultFound: "No result found.",
        addToCart: "Add to cart",
        searchForProduct: "Search for products",
        scrollTo: "Scroll to results",
        showFilter: "Show filters",
        hideFilter: "Apply filters",
        selectedFilter: "Active filters",
        clearAll: "Clear all",
        noPageFound: "No page found",
        outOfStock: "Out of stock",
        sort_by: "Sort by",
        sort_labels: {
          default: "Art.Nr. (all colors)",
          title_asc: "Art.Nr. (Grouped)",
          published_at_desc: "Color",
          recently_ordered_count_desc: "Most popular",
        },
      },
      de: {
        yes: "Ja",
		no: "Nein",
        weight: "Gewicht",
        composition: "Zusammensetzung",
        certificates: "Zertifikate",
        swatch: "Farbe",
        search: "Current search",
        noCollectionFound: "No collection found",
        allProducts: "See all products",
        matching: "matching",
        sortBy: "Sort by",
        relevance: "Art.Nr. (all colors)",
        resultsFound: "results found",
        oneResultFound: "1 result found",
        noResultFound: "No result found.",
        addToCart: "Add to cart",
        searchForProduct: "Search for products",
        scrollTo: "Scrollen Sie zu den Ergebnissen",
        showFilter: "Filter anzeigen",
        hideFilter: "Filter anwenden",
        selectedFilter: "Aktive Filter",
        clearAll: "Löschen",
        noPageFound: "No page found",
        outOfStock: "Out of stock",
        sort_by: "Sortiere nach",
        sort_labels: {
          default: "Art.-Nr. (Alle Farben)",
          title_asc: "Art.-Nr. (Gruppiert)",
          published_at_desc: "Farbe",
          recently_ordered_count_desc: "Am beliebtesten",
        },
      },
      nl: {
        yes: "Ja",
		no: "Nee",
        weight: "Gewicht",
        composition: "Samenstelling",
        certificates: "Certificaten",
        swatch: "Kleur",
        search: "Current search",
        noCollectionFound: "No collection found",
        allProducts: "See all products",
        matching: "matching",
        sortBy: "Sort by",
        relevance: "Art.Nr. (all colors)",
        resultsFound: "gevonden",
        oneResultFound: "1 gevonden",
        noResultFound: "Geen resultaten gevonden.",
        addToCart: "Add to cart",
        searchForProduct: "Search for products",
        scrollTo: "Scroll naar resultaten",
        showFilter: "Filters tonen",
        hideFilter: "Filters toepassen",
        selectedFilter: "Actieve filters",
        clearAll: "Wissen",
        noPageFound: "No page found",
        outOfStock: "Out of stock",
        sort_by: "Sorteer op",
        sort_labels: {
          default: "Art.Nr. (alle kleuren)",
          title_asc: "Art.Nr. (gegroepeerd)",
          published_at_desc: "Kleur",
          recently_ordered_count_desc: "Meest populair",
        },
      },
      fr: {
        yes: "Oui",
		no: "Non",
        weight: "Poids",
        composition: "Composition",
        certificates: "Certificats",
        swatch: "Couleur",
        search: "Current search",
        noCollectionFound: "No collection found",
        allProducts: "See all products",
        matching: "matching",
        sortBy: "Sélectionner",
        relevance: "Art.Nr. (all colors)",
        resultsFound: "results found",
        oneResultFound: "1 result found",
        noResultFound: "No result found.",
        addToCart: "Add to cart",
        searchForProduct: "Search for products",
        scrollTo: "Aller aux résultats",
        showFilter: "Afficher les filtres",
        hideFilter: "Appliquer des filtres",
        selectedFilter: "Filtres actifs",
        clearAll: "Effacer",
        noPageFound: "No page found",
        outOfStock: "Out of stock",
        sort_by: "Sélectionner",
        sort_labels: {
          default: "N° Art. (Toutes les couleurs)",
          title_asc: "N° Art. (Regroupé)",
          published_at_desc: "Couleur",
          recently_ordered_count_desc: "Les plus populaires",
        },
      },
      es: {
        yes: "Sí",
		no: "No",
        weight: "Peso",
        composition: "Composición",
        certificates: "Certificados",
        swatch: "Color",
        search: "Current search",
        noCollectionFound: "No collection found",
        allProducts: "See all products",
        matching: "matching",
        sortBy: "Sort by",
        relevance: "Art.Nr. (all colors)",
        resultsFound: "results found",
        oneResultFound: "1 result found",
        noResultFound: "No result found.",
        addToCart: "Add to cart",
        searchForProduct: "Search for products",
        scrollTo: "Desplazarse a resultados",
        showFilter: "Mostrar filtros",
        hideFilter: "Aplicar filtros",
        selectedFilter: "Filtros activos",
        clearAll: "Claros",
        noPageFound: "No page found",
        outOfStock: "Out of stock",
        sort_by: "Ordenar por",
        sort_labels: {
          default: "Art.Núm. (Todos los colores)",
          title_asc: "Art.Núm (Agrupado)",
          published_at_desc: "Color",
          recently_ordered_count_desc: "Más popular",
        },
      }
    }
  
  if(!algolia.language || !(algolia.language in algolocal)){
      algolia.language = 'en';
  }
  algolia.translations = algolocal[algolia.language];
  
  algolia.translation_helpers = {
    
  };

}(algoliaShopify));

/* #3. */
/* See https://community.algolia.com/shopify/hogan-helpers.html */

(function (algolia) {
    'use strict';
    var _ = algolia._;
    var formatPrice = function formatPrice(value) {
      let priceInp = value.toString();
      let priceOut = priceInp.slice(0,-2) + ',' + priceInp.slice(-2);
      return priceOut;
    };

    algolia.helpers = {
        collectionName: function collectionName(text, render){
          var aaCollName = text;
          if(typeof this.handle !== 'undefined'){
            // prep lookup handle //
            var aaCollHandle = '/collections/' + this.handle;
            if(algolia.language !== 'en'){
              aaCollHandle = '/' + algolia.language + aaCollHandle;
            }
            // find collection in main-menu //
            var $aaCollMatchElem = $('.main-menu a[href="'+aaCollHandle+'"]').last();
            if($aaCollMatchElem.length == 1){
              var aaCollMatchTxt = $aaCollMatchElem.text();
              if(aaCollMatchTxt != ''){
                // find closest head collection //
                var aaCollClosestHd = $aaCollMatchElem.closest('.main-submenu-col').find('a.submenu-col-title').text();
                if(aaCollClosestHd != ''){
                  aaCollMatchTxt = '<em>'+aaCollClosestHd + '</em> ' + aaCollMatchTxt;
                }
                aaCollName = aaCollMatchTxt; 
              }
            } else if(algolia.language !== 'en' && typeof this.body_html_safe === 'string'){
              // look at this.body_html_safe //
              var aaRegex = new RegExp('\\[' + algolia.language + ':([^\\]]+)\\]');
              var aaRegexMatch = this.body_html_safe.match(aaRegex);
              if(aaRegexMatch && aaRegexMatch[1]){
                aaCollName = aaRegexMatch[1].trim();
              }
            }
          }
          return aaCollName;
        },
        collectionImg: function collectionImg(text, render){
          var aaCollImg = render(text);
          if(aaCollImg != ''){
            var aaCollResize = aaCollImg + '&width=200';
            aaCollImg = '<img src="'+aaCollResize+'">';
          }
          return aaCollImg;
        },
        namedLang: function namedLang(namedTag){
			    var nmdAl = algolia.language;
          var nmdAlPref = nmdAl+'__'+namedTag;
          return '[[ named_tags.' + nmdAlPref + ' ]]';
        },
      	formatFacetCount: function formatFacetCount(text, render) {
          return parseInt(render(text));
        },
      	prepCompo: function prepCompo(text, render) {
          //var ai_comprep = render(text).replace('/', ' / ');
          var ai_comprep = render(text).split('/').join(' / ');
          return ai_comprep;
        },
        wshlst: function wshlst(text, render) {
          var wsh_sku = this.sku.replace('/','-');
          var wsh_html = '<span class="wshlst" data-sku="' + wsh_sku  + '" data-product="' + this.id + '" data-variant="' + this.objectID + '"></span>';
          return wsh_html;
        },
      	productCert: function productCert() { 
          var certs_html = '';
          var certs_1_html = '';
          var certs_2_html = '';
          var certs_3_html = '';
          if(this.product_type && this.product_type == 'Special'){
            certs_3_html += '<img loading="lazy" src="//www.nooteboomtextiles.com/cdn/shop/t/456/assets/logo-special_design.svg?v=96213850449557371851776931111" alt="Special Design" class="aa-svgimg">';
          }
          if(this.named_tags['Quality name']){
            var qlty_check = this.named_tags['Quality name'];
            if(qlty_check.indexOf("DWR") > -1){
              certs_1_html += '<img loading="lazy" src="//www.nooteboomtextiles.com/cdn/shop/files/cert_quick_dry_63x63.png?v=936523436417548987" width="36" height="36" alt="Quick Dry logo">';
            }
            if(qlty_check.indexOf("UPF50") > -1){
              certs_1_html += '<img loading="lazy" src="//www.nooteboomtextiles.com/cdn/shop/files/cert_upf50_130x68.png?v=18197836881592403895" width="56" height="29" alt="UPF50 logo">';
            }
          }
          if(this.named_tags.Certificates){
            var certs_check = this.named_tags.Certificates;
            var certs_check_low = certs_check.toString().toLowerCase();
            if(certs_check.indexOf("TENCEL™ Lyocell") > -1){
              certs_2_html += '<img loading="lazy" src="//www.nooteboomtextiles.com/cdn/shop/files/cert_lenzing_tencel_130x68.png?v=543354574739471212" width="56" height="29" alt="TENCEL™ Lyocell logo">';
            }
            if(certs_check.indexOf("ECOVERO™ Viscose") > -1){
              certs_2_html += '<img loading="lazy" src="//www.nooteboomtextiles.com/cdn/shop/files/cert_lenzing_ecovero_130x68.png?v=4914021571424713744" width="56" height="29" alt="ECOVERO™ Viscose logo">';
            }
            if(certs_check_low.indexOf("oeko-tex standard 100 product class ii") > -1){
              certs_3_html += '<img loading="lazy" src="//www.nooteboomtextiles.com/cdn/shop/files/cert_oekotex-C2-5_130x68.png?v=16165410556573084584" width="56" height="29" alt="Oeko-Tex certificate">';
            } else if(certs_check_low.indexOf("oeko-tex standard 100 product class i") > -1){
              certs_3_html += '<img loading="lazy" src="//www.nooteboomtextiles.com/cdn/shop/files/cert_oekotex-C1-5_130x68.png?v=17708748017712658522" width="56" height="29" alt="Oeko-Tex certificate">';
            } else if(certs_check_low.indexOf("oeko-tex standard 100 product class i - organic") > -1){
              certs_3_html += '<img loading="lazy" src="//www.nooteboomtextiles.com/cdn/shop/files/cert_oekotex-C1-O_130x68.png?v=17553006570469867880" width="56" height="29" alt="Oeko-Tex certificate">';
            } else if(certs_check_low.indexOf("oeko-tex standard 100") > -1){
              certs_3_html += '<img loading="lazy" src="//www.nooteboomtextiles.com/cdn/shop/files/cert_oekotex-C-5_130x68.png?v=662708709783386906" width="56" height="29" alt="Oeko-Tex certificate">';
            }
            if(certs_check_low.indexOf("mulesing free") > -1){
              certs_1_html += '<img loading="lazy" src="//www.nooteboomtextiles.com/cdn/shop/files/cert_mulesing_free_63x63.png?v=1009117029456429454" width="36" height="36" alt="Mulesing Free logo">';
            }
            if(certs_check_low.indexOf("recycled") > -1  && certs_check_low.indexOf("global recycled") == -1){
              certs_1_html += '<img loading="lazy" src="//www.nooteboomtextiles.com/cdn/shop/files/cert_recycled_63x63.png?v=12103074361863491514" width="36" height="36" alt="Recycled logo">';
            } else {
              if(this.named_tags.Composition){
                var certc_check = this.named_tags.Composition;
                if(certc_check.indexOf("%OCO") > -1){
                  certs_1_html += '<img loading="lazy" src="//www.nooteboomtextiles.com/cdn/shop/files/cert_GOTS-6_130x68.png?v=13231779312980909488" alt="GOTS - Global Organic Textile Standard" width="56" height="29">';
                }
                if(certc_check.indexOf("%RCO") > -1 || certc_check.indexOf("%RPL") > -1 || certc_check.indexOf("%RPA") > -1){
                  certs_2_html += '<img loading="lazy" src="//www.nooteboomtextiles.com/cdn/shop/files/cert_GRS-4_130x68.png?v=12173072489461574943" alt="GRS - Global Recycled Standard" width="56" height="29">';
                }
              }
            }
          }
          certs_html = '<span class="cert-labels">';
            certs_html += '<span class="cert-label">'+certs_1_html+'</span>';
            certs_html += '<span class="cert-label">'+certs_2_html+'</span>';
            certs_html += '<span class="cert-label">'+certs_3_html+'</span>';
            if(this.named_tags.Productphoto && this.named_tags.Productphoto == 'design'){
              certs_html += '<span class="cert-label cert-label-nophoto"><img src="//www.nooteboomtextiles.com/cdn/shop/files/label-nophoto_115x.png?v=14647655377173717599" width="115" height="30" loading="lazy" alt="This is not a photo"></span>';
            }
          certs_html += '</span>';
          return certs_html;
      	},
      	productLabels: function productLabels() {
          var label_green_html = '';
          var label_red_html = '';
          var label_black_html = '';
          var label_act_active = 0;
          if(typeof cust_globagent_code !== 'undefined'){
            if(cust_globagent_code === 'a4'){
              if(this.meta.group_prices.Prices){
                var label_check_date = parseInt(main_glob_date);
                if(this.meta.group_prices.Prices.indexOf('SPC:MRT26_01') > -1 && label_check_date > 20260311 && label_check_date < 20260401){
                  label_red_html = '<span class="red-label">SALE</span>';
                  label_act_active = 1;
                }
              }
            }
          }
          if(this.named_tags.Collection){
			      var label_check_coll = this.named_tags.Collection;
            if(label_check_coll.indexOf("Special offers") > -1){
              	label_red_html = '<span class="red-label">SALE</span>';
            }
		      }
          if(this.named_tags.Labels){
            var label_check_stat = this.named_tags.Labels;
            if(label_check_stat == 'Almost sold out'){
              	label_black_html = '<span class="black-label">ALMOST SOLD OUT</span>';
            }
          }
          if(this.named_tags.Status){
            var label_check_stat = this.named_tags.Status;
            if(label_check_stat == '9'){
              	label_black_html = '<span class="pink-label">LAST PIECE</span>';
            }
          }
          if(this.named_tags.Season){
            var label_check_stat = this.named_tags.Season;
            if(label_check_stat == 'STD' && label_act_active != 1){
              if(this.created_at){
                var label_check_dateStr = this.created_at;
                var label_check_dateDate = new Date(label_check_dateStr);
                label_check_dateDate.setDate(label_check_dateDate.getDate() + 151);
                var label_check_dateCurr = new Date();
                var label_check_dateDiff = label_check_dateDate.getTime() - label_check_dateCurr.getTime();
                if(label_check_dateDiff > 0){
                  label_green_html = '<span class="green-label">NEW</span>';
                }
              }
            } 
            //else if(label_check_stat == 'T001' || label_check_stat == 'T002'){
            //  label_black_html = '<span class="hemmers-label">HEMMERS ITEX</span>';
            //}
          }
		      return label_green_html + label_red_html + label_black_html;
        },
        instantsearchLink: function instantsearchLink(text) {
            var instLinkPref = '';
            if(text !== ''){
              instLinkPref = text;
            } else if(algolia.language !== 'en'){
              instLinkPref = '/' + algolia.language;
            }
            return instLinkPref + '/products/' + this.handle;
        },
      	isSpecial: function isSpecial() {
          var specrt='';
          if(this.product_type && this.product_type == 'Special'){
            specrt = '<span class="aa-isspecial">Special Design</span>';
          }
          return specrt;
        },
        highLightSku: function highLightSku() {
          if (this._indx_used == 'ntb_en_products_title_asc' && typeof this.named_tags.MainProduct !== 'undefined'){
            return this.named_tags.MainProduct;
          }
          return this._highlightResult.sku.value;
        },
        hemmSku: function hemmSku() {
          if(this.named_tags.HemmersArtnr && this.named_tags.HemmersArtnr != ''){
            return this.named_tags.HemmersArtnr;
          } else {
            return this.sku;
          }
        },
        fastButtons: function fastButtons(text,render) {
          	var fast_buttons = '';
          	if(this.named_tags.xvardata){
              var fast_data = this.named_tags.xvardata;
              var fast_data_Arr = fast_data.split('|').reverse();
              var fast_data_inCart = text;
              var fast_data_pref = '/products/';
              if(algolia.language !== 'en'){
              	fast_data_pref = '/' + algolia.language + fast_data_pref;
              }
              var fast_data_fvj = 0;
              if(this.named_tags.CustArtCode){
                if(this.named_tags.CustArtCode.indexOf('FVJ') > -1){
                  fast_data_fvj = 1;
                }  
              }
              var fast_data_handle = fast_data_pref + this.handle;
              var fast_data_handle_suff = '';
              var fast_data_artnr = this.sku;
              $.each(fast_data_Arr, function (index, fast_data_Part) {
                if(fast_data_Part != ''){
                  	var fast_button_Arr = fast_data_Part.split('#');
                  	var fast_button_Chk = fast_button_Arr.length;
                    if(fast_button_Chk == 3){
                      var fast_button_type = fast_button_Arr[0].toLowerCase();
                      var fast_button_lng = fast_button_Arr[1];
                      var fast_button_ava = fast_button_Arr[2];
                      // FVJ //
                      if(fast_button_type == 'rolls' && fast_data_fvj == 1 && fast_button_ava == 5000){
                        fast_button_ava = 0;
                      }
                      if(fast_button_ava > 0){
                        // Build button //
                        var fast_button_html = '';
                        var fast_button_desc = fast_data_inCart;
                        var fast_button_class = '';
                        var fast_button_img = '';
                        if(fast_button_lng > 1){
                          fast_button_desc = fast_button_lng + 'm';
                          fast_button_class = ' desc_down';
                        }
                        var fast_button_desc_title = fast_button_desc;
                        if(fast_button_type.indexOf('roll') > -1){
                          fast_button_img = '<img src="//www.nooteboomtextiles.com/cdn/shop/t/456/assets/icon-product-roll.svg?v=144448790106455439961776931089" class="action-button-icon-type" alt="roll icon">';
                        } else if(fast_button_type.indexOf('fold') > -1){
                          fast_button_img = '<img src="//www.nooteboomtextiles.com/cdn/shop/t/456/assets/icon-product-fold.svg?v=147834511533833159861776931087" class="action-button-icon-type" alt="folded icon">';
                        } else if (fast_button_type.indexOf('small') > -1){
                          fast_button_img = '<img src="//www.nooteboomtextiles.com/cdn/shop/t/456/assets/icon-product-fold.svg?v=147834511533833159861776931087" class="action-button-icon-type" alt="small piece icon">';
                          fast_button_desc_title = fast_button_lng + 'm - one only - ';
                          fast_button_class = ' desc_down desc_smallp';
                        }
                        fast_data_handle_suff = '/' + encodeURIComponent(fast_button_type);  
                        fast_button_html += '<a href="#" class="fastadd-ais-button ais-hit--button action--button action---plus' + fast_button_class + '" title="' + fast_button_desc_title + ' ' + fast_data_inCart + '" tabindex="0" data-fastais-handle="' + fast_data_handle + fast_data_handle_suff + '" data-fastais-artnr="' + fast_data_artnr + '" data-fastais-var="' + fast_button_type + '">';
                        	fast_button_html += '<span class="action-button-icon-plus">+</span>';
                            fast_button_html += fast_button_img;
                        	fast_button_html += '<span class="action-button-desc">' + fast_button_desc + '</span>';
                        fast_button_html += '</a>';
                        // reset small piece //
                        if(fast_button_type.indexOf('small') > -1 && fast_button_ava != 1000){
                          fast_button_html = '';
                        }
                        fast_buttons += fast_button_html;
                      }
                    }
                }
              });
            }
            if(this.named_tags.Status){
              var fast_status = this.named_tags.Status;
              if(fast_buttons == '' || fast_status == '9'){
                fast_buttons = '<a href="#0" class="fastmore-ais-button action--button">info</a>';
              }
            }
          	return fast_buttons;
        },
        customerPrice: function (text, render) {
          var ashop_date = parseInt(main_glob_date);
          var aprod_sku = this.sku;
          var aprod_sku_main = aprod_sku.split('/')[0];
          var aprod_group = '';
          if(this.named_tags.Group){
            var aprod_group = this.named_tags.Group.trim().toUpperCase();
          }
          var aprod_season = '';
          if(this.named_tags.Season){
            var aprod_season = this.named_tags.Season.trim().toUpperCase();
          }
          var acust_campagnes = cust_glob_cmpg;
          var acust_price_offer = 99900;
          var acust_offer_active = 0;  
          var adataArr = text.split('===');
          var aprod_correction = 'N'; // tmp 
          if(this.tags && this.tags.indexOf('upx') === -1){ // tmp 
           	aprod_correction = 'Y'; // tmp 
          } // temp 
          var acust_typeagent = adataArr[3]; // tmp 
          var aprod_typestatus = '0'; // tmp 
          if(this.named_tags.Status){ // tmp 
          	aprod_typestatus = this.named_tags.Status; // tmp 
          } 
          // below swap with customer_prices - 220929 //
          if(aprod_group !== '' && aprod_season !== ''){
            var acust_groupoffer_string = adataArr[4]; //customer_group_prices
            if(acust_groupoffer_string !== ''){
                var aprod_group_season = aprod_group + '_' + aprod_season;
              	var aprice_customer_group_Arr = acust_groupoffer_string.split('|');
              	$.each(aprice_customer_group_Arr, function (index, aprice_customer_group_Part) {
                	var aprice_customer_group_part_Arr = aprice_customer_group_Part.split(':');
                  	var aprice_customer_group_check = aprice_customer_group_part_Arr[0].trim().toUpperCase();
                    if(aprice_customer_group_check === aprod_group_season){
						var aprod_price_customergroup_str = aprice_customer_group_part_Arr[1];
                      	acust_price_offer = Math.round(aprod_price_customergroup_str);
                      	acust_offer_active = 1;
                      	return false; //break
                    }
                });
          	}
          }
          var acust_offer_string = adataArr[2]; //customer_prices
          if(acust_offer_string !== '' && acust_offer_active === 0){
            var aprice_customer_Arr = acust_offer_string.split('|');
            $.each(aprice_customer_Arr, function (index, aprice_customer_Part) {
            	var aprice_customer_part_Arr = aprice_customer_Part.split(':');
              	var acustomer_sku_Match = aprice_customer_part_Arr[0].trim().toUpperCase();
                if(acustomer_sku_Match === aprod_sku || acustomer_sku_Match === aprod_sku_main){
					var aprod_price_customer_str = aprice_customer_part_Arr[1];
                  	acust_price_offer = Math.round(aprod_price_customer_str);
                  	acust_offer_active = 1;
                }
            });
          }
          // GET XX / CAMP //
          var aprod_price_list = 99900;
          var aprod_price_lpc = 99900;
          var aprod_price_spc = 99900;
          var alpc_recipe = '';
          var aspc_recipe = '';
		  if (this.meta.group_prices && this.meta.group_prices.Prices) {
            var aprod_price_string = this.meta.group_prices.Prices;
            var aprice_recipe_Arr = aprod_price_string.split('|');
            $.each(aprice_recipe_Arr, function (index, aprice_recipe_Part) {
            	var aprice_recipe_part_Arr = aprice_recipe_Part.split(':');
              	var aprice_recipe_part_check  = aprice_recipe_part_Arr[0].trim().toUpperCase();
                if(aprice_recipe_part_check === 'XX'){
					var aprod_price_list_str = aprice_recipe_part_Arr[1];
                  	aprod_price_list = Math.round(aprod_price_list_str);
                  	// START MINUS EURO tmp //
                  	// END MINUS EURO //
                  	aprod_price_lpc = aprod_price_list;
                } else if(aprice_recipe_part_check === 'LPC' || aprice_recipe_part_check === 'SPC'){
                    if(acust_campagnes !== '' && acust_campagnes !== '(NONE)'){
                        var acust_campagnes_Arr = acust_campagnes.split('|');
                        var acampagne_Data = aprice_recipe_part_Arr[1];
                        var acampagne_Arr = acampagne_Data.split(';');
                        var acampagne_Name = acampagne_Arr[0];
                        var acampagne_Forvari = acampagne_Arr[1];
                        var acampagne_Start = parseInt(acampagne_Arr[2]);
                        var acampagne_End = parseInt(acampagne_Arr[3]);
                        var acampagne_Input = acampagne_Arr[6];
                        if(acust_campagnes_Arr.indexOf(acampagne_Name) > -1){ // name match
                            if(ashop_date >= acampagne_Start && ashop_date <= acampagne_End){ // date match
                                if(aprice_recipe_part_check === 'LPC'){
                                    alpc_recipe = acampagne_Data;
                                } else if(aprice_recipe_part_check === 'SPC'){
                                    aspc_recipe = acampagne_Data;
                                }
                            }
                    	}
                    }
                }
            });
          }
          // LPC //
          if(alpc_recipe !== ''){
            var alpc_calc_Arr = alpc_recipe.split(';');
          	var alpc_calc_Cat = alpc_calc_Arr[4];
            var alpc_calc_Catval = alpc_calc_Arr[5];
            var alpc_calc_CatvalCent  = Math.round(alpc_calc_Catval * 100);
            if(alpc_calc_Cat === 'A'){
            	aprod_price_lpc = aprod_price_list + alpc_calc_CatvalCent;
            } else if(alpc_calc_Cat === 'D'){
            	var alpc_calc_perc_disc = aprod_price_list * alpc_calc_Catval;
              	aprod_price_lpc = Math.round(alpc_calc_perc_disc);
            } else if(alpc_calc_Cat === 'P'){
              	aprod_price_lpc = alpc_calc_CatvalCent;
            }
            // LPC max //
            var alpc_calc_Max = alpc_calc_Arr[7];
            var alpc_calc_MaxCent = Math.round(alpc_calc_Max * 100);
            var aprod_price_lpc_max = aprod_price_list + alpc_calc_MaxCent;
            if(aprod_price_lpc_max > aprod_price_list){
                if(aprod_price_lpc > aprod_price_lpc_max){
                  aprod_price_lpc = aprod_price_lpc_max;
                }
            } else if(aprod_price_lpc_max < aprod_price_list){
            	if(aprod_price_lpc < aprod_price_lpc_max){
                	aprod_price_lpc = aprod_price_lpc_max;
              	}
            }
          }
          // SPC //
          if(aspc_recipe !== ''){
            var aspc_calc_Arr = aspc_recipe.split(';');
            var aspc_calc_Cat = aspc_calc_Arr[4];
			var aspc_calc_Catval = aspc_calc_Arr[5];
            var aspc_calc_CatvalCent  = Math.round(aspc_calc_Catval * 100);
            var aspc_calc_Input = aspc_calc_Arr[6];
            if(aspc_calc_Input === '1'){ // calc inp
              var aspc_calc_Price = aprod_price_list;
            } else if(aspc_calc_Input === '3'){
              if(acust_price_offer > 0 && acust_price_offer < 99900){
                var aspc_calc_Price = acust_price_offer;
              } else {
                var aspc_calc_Price = aprod_price_lpc;
              }
            } else {
              var aspc_calc_Price = aprod_price_lpc;
            }
            if(aspc_calc_Cat === 'A'){
            	aprod_price_spc = aspc_calc_Price + aspc_calc_CatvalCent;
            } else if(aspc_calc_Cat === 'D'){
            	var aspc_calc_perc_disc = aspc_calc_Price * aspc_calc_Catval;
              	aprod_price_spc = Math.round(aspc_calc_perc_disc);
            } else if(aspc_calc_Cat === 'P'){
            	aprod_price_spc = aspc_calc_CatvalCent;
            }
           	// SPC max //
			var aspc_calc_Max = aspc_calc_Arr[7];
            var aspc_calc_MaxCent = Math.round(aspc_calc_Max * 100);
            // SPC NEW max //
            var aprod_max_input = aprod_price_lpc;
            var aprod_price_spc_max = aprod_max_input + aspc_calc_MaxCent;
            if(aprod_price_spc_max > aprod_max_input){
            	if(aprod_price_spc > aprod_price_spc_max){
                	aprod_price_spc = aprod_price_spc_max;
                }
            } else if(aprod_price_spc_max < aprod_max_input){
                if(aprod_price_spc < aprod_price_spc_max){
					aprod_price_spc = aprod_price_spc_max;
                } 
            } 
          }
          // OUTP //
          var aunit = 'm';
          var aprod_price_orig = aprod_price_list;
          var aprod_price_sell = aprod_price_list;
          if(acust_price_offer > 0 && acust_price_offer < 99900){
            aprod_price_sell = acust_price_offer;
            aprod_price_orig = acust_price_offer;
            if(acust_price_offer < aprod_price_lpc){
              aprod_price_orig = aprod_price_lpc;
            }
          } else if(aprod_price_lpc < aprod_price_sell){
            aprod_price_sell = aprod_price_lpc;
          } else if(aprod_price_lpc > aprod_price_sell){
            aprod_price_sell = aprod_price_lpc;
            aprod_price_orig = aprod_price_lpc;
          }
          if(aprod_price_spc < aprod_price_sell){
            aprod_price_sell = aprod_price_spc;
          }
		  if(aprod_price_sell < aprod_price_orig){
            return '<span class="orig-meter-price">' + formatPrice(aprod_price_orig) + '</span><strong>' + formatPrice(aprod_price_sell) +'</strong> / ' + aunit ;
          } else {
            return '<strong>' + formatPrice( aprod_price_sell) + '</strong> / ' + aunit ;
          }
        },
        thumbImage: function thumbImage(text, render){
          var image = this._distinct ? this.product_image : this.image;
          if (!image) {
            return 'https://cdn.shopify.com/s/images/admin/no-image-compact.gif';
          }
          var aaImageResized = image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_80x80.$2');
          if(window.Shopify.cdnHost){
              aaImageResized = aaImageResized.replace('cdn.shopify.com/s/files/1/0016/0088/0728', window.Shopify.cdnHost + '/shop');
          }
          return aaImageResized;
        },
        mediumImage: function mediumImage(text, render){
          var image = this._distinct ? this.product_image : this.image;
          if (!image) {
            return 'https://cdn.shopify.com/s/images/admin/no-image-compact.gif';
          }
          var aaImageResized = image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_240x240.$2');
          if(window.Shopify.cdnHost){
              aaImageResized = aaImageResized.replace('cdn.shopify.com/s/files/1/0016/0088/0728', window.Shopify.cdnHost + '/shop');
          }
          return aaImageResized;
        }
    };

    /* Create an Hogan lambda, which doesn't respect the mustache doc */
    algolia.hoganHelpers = _.reduce(Object.assign({}, algolia.helpers, algolia.translation_helpers), function (res, helper, name) {
        res[name] = function () {
            return function (text) {
                var render = function (value) {
                    return Hogan.compile(value, algolia.hoganOptions).render(this);
                }.bind(this);
                return helper.call(this, text, render);
            }.bind(this);
        };
        return res;
    }, {});
}(algoliaShopify));

/* #4. */
(function (algolia) {
  if (!algolia.config.autocomplete_enabled) return;

  var _ = algolia._,
      $ = algolia.jQuery;

  var autocomplete; 
  var algolia_CC_strip = ' NOT "handle":"my-specials" ';
  var algolia_AC_strip = ' NOT "product_type":"Sample" AND NOT "product_type":"Special" ';
  if(!!cust_globspec_col && cust_globspec_col.length > 3){
    var algolia_ADD_adj = cust_globspec_col;
    if(algolia_ADD_adj.substring(0, 1) == 'c' ){
      algolia_AC_strip = ' "named_tags.SpecialFor":"'+algolia_ADD_adj+'" OR "product_type":"Fabric" ';
    }
  }
  /*if($('body').hasClass('agc__A4') == false){
    algolia_CC_strip += ' NOT "handle":"hemmers-only-basics" ';
    algolia_CC_strip += ' AND NOT "handle":"hemmers-only-aw-25-26" ';
    algolia_AC_strip += ' AND NOT "vendor":"HemmersItex" ';
    algolia_AC_strip += ' AND NOT "named_tags.Season":"T001" ';
    algolia_AC_strip += ' AND NOT "named_tags.Season":"T002" ';
  }*/

  function index (name) {
    return algolia.client.initIndex('' + algolia.config.index_prefix + name);
  }

  function addPositionToHits(hits, queryID, indexUsed) {
    return hits.map(function (entry, index) {
      entry._position = index + 1;
      entry._queryID = queryID;
      entry._indx_used = indexUsed;
      return entry
    })
  }

  function autocompleteSection (section) {      
    var params = autocomplete[section];
    if (params.enabled !== true) return null;

    var templates = {
      empty: function displayEmptyResultSet (props) {
        return algolia.render(params.templates.empty, Object.assign({}, props, { translations: algolia.translations }));
      },
      suggestion: function displaySuggestion (hit) {
        if(hit.handle !== "my-specials"){
          return algolia.render(params.templates.hit, Object.assign({ _distinct: params.distinct }, hit, {translations: algolia.translations}));
        }
      }
    };
    if (params.templates.footer) {
      templates.footer = function displayFooter (props, content) {
        if (content.nbHits <= params.hitsPerPage) return null;
        if (!autocomplete.showFooter) return null;

        return algolia.render(params.templates.footer, {
          query: props.query,
          nbHits: content.nbHits,
          translations: algolia.translations,
          helpers: algolia.helpers
        });
      }
    }

    return {
      name: section,
      source: function(query, callback) {
        /* NEW INTENTION CORRECTION */
        query = intentionCorrection(query);
        if(section == "collections"){
          var searchOpts = {
            clickAnalytics: true,
            hitsPerPage: params.hitsPerPage,
            filters: algolia_CC_strip
          };
        } else {
          var searchOpts = {
            clickAnalytics: true,
            hitsPerPage: params.hitsPerPage,
            filters: algolia_AC_strip
          };
        }
        if (params.distinct) {
          searchOpts.distinct = true;
        }
        if(typeof cust_glob_did == 'string' && typeof main_globlang == 'string'){
          if(cust_glob_did == ''){
              searchOpts.userToken = main_globlang;
          } else {
              searchOpts.userToken = cust_glob_did;
          } 
        }
        var suspiciousACQuery = 
          /\(tg:[a-z0-9]+\)/i.test(query);
        if (!suspiciousACQuery) {
        //if(query.indexOf('%pa') < 0 && query.indexOf('%25pa') < 0){
          index(section).search(query, searchOpts).then(function(answer) {
            var hits = addPositionToHits(answer.hits, answer.queryID, 'ntb_en_'+section);
            callback(hits, answer);
          });
        }
      },
      displayKey: 'title',
      templates: templates
    }
  };

  autocomplete = algolia.autocomplete = {
    collections: {
      enabled: algolia.config.index_collections,
      hitsPerPage: algolia.config.collections_autocomplete_hits_per_page,
      index: index('collections'),
      templates: {
        empty: algolia.compileTemplate('autocomplete_collections_empty'),
        hit: algolia.compileTemplate('autocomplete_collection')
      }
    },
    colors: algolia.config.colors,
    debug: algolia.config.autocomplete_debug,
    poweredBy: algolia.config.powered_by,
    products: {
      enabled: algolia.config.index_products,
      distinct: algolia.config.show_products,
      hitsPerPage: algolia.config.products_autocomplete_hits_per_page,
      index: index('products'),
      templates: {
        empty: algolia.compileTemplate('autocomplete_products_empty'),
        footer: algolia.compileTemplate('autocomplete_footer'),
        hit: algolia.compileTemplate('autocomplete_product')
      },
    },
    selector: algolia.config.input_selector + ', .algolia-shopify-autocomplete',
    showFooter: algolia.config.instant_search_enabled,
    storeName: algolia.storeName,
    templates: {
      dropdown: algolia.compileTemplate('autocomplete'),
      empty: '<div></div>'
    }
  };
  
function easy_autoComplete() {
  	var templates = {
    	empty: function displayEmptyResultSet (props) {
          return algolia.render(algolia.compileTemplate('autocomplete_products_empty'), Object.assign({}, props, { translations: algolia.translations }));
        },
        suggestion: function displaySuggestion (hit) {
          return algolia.render(algolia.compileTemplate('autocomplete_product'), Object.assign({}, hit, {translations: algolia.translations}));
        }
	};
	return {
		name: 'products',
		source: function(query, callback) {
          query = intentionCorrection(query);
          var searchOpts = {
            hitsPerPage: 24,
            distinct: true,
            clickAnalytics: true,
            filters: algolia_AC_strip
          };
          index('products_title_asc').search(query, searchOpts).then(function(answer) {
            var hits = addPositionToHits(answer.hits, answer.queryID, 'ntb_en_products_title_asc');
            $('.easyorder-searchcontainer .aa-dropdown-menu').scrollTop(0);
          	callback(hits, answer);
          });
      },
      displayKey: function(suggestion) {titleArr = suggestion.title.split('/'); return titleArr[0] },
      templates: templates
    }
}  

$(document).ready(function(){
    if($('.easyorderSearchbox').length > 0){
      $('.easyorderSearchbox').autocomplete({ 
        hint: false,
        autoselect: true,
        debug: false,
      }, _.compact([
        easy_autoComplete()
      ])).on('autocomplete:selected', function(event, suggestion, dataset, context){
        easy_step2_colors();
      });
    }
    
    autocomplete.$input = $(autocomplete.selector);
    autocomplete.$input.autocomplete({
      debug: autocomplete.debug,
      hint: false,
      appendTo: 'body',
      templates: {
        dropdownMenu: algolia.render(autocomplete.templates.dropdown, {
          storeName: autocomplete.storeName,
          with: {
            collections: autocomplete.collections.enabled,
            products: autocomplete.products.enabled
          }
        }),
        empty: autocomplete.templates.empty
      }
    }, _.compact([
      autocompleteSection('collections'),
      autocompleteSection('products')
    ]));

    // Hack to handle buggy onclick event on iOS
    autocomplete.$input.each(function () {
      var data = $(this).data('aaAutocomplete');
      var dropdown = data.dropdown;
      var suggestionClass = '.' + dropdown.cssClasses.prefix + '-' + dropdown.cssClasses.suggestion;
      var onSuggestionClick = dropdown._onSuggestionClick.bind(dropdown);

      var touchmoved;
      dropdown.$menu.on('touchend', suggestionClass, function (e) {
        if(touchmoved === false) {
          e.preventDefault();
          e.stopPropagation();
          onSuggestionClick.apply(this, arguments);
        }
      }).on('touchmove', function (){
        touchmoved = true;
      }).on('touchstart', function(){
        touchmoved = false;
      });
    });

    autocomplete.$input.on('autocomplete:selected', function (obj, datum, name) {
      if (name === 'products') {
        var addVariantId = !autocomplete.products.distinct && datum.objectID !== datum.id;
        //if(aaPushAuto){
        //  aaPushAuto(datum.handle, datum._indx_used, datum._queryID, datum.objectID, datum._position);
        //}
        window.location.href = main_globlang_pref + '/' + name + '/' + datum.handle;
      } else if (name === 'articles') {
        window.location.href = main_globlang_pref + '/blogs/' + datum.blog.handle + '/' + datum.handle;
      } else {
        window.location.href = main_globlang_pref + '/' + name + '/' + datum.handle;
      }
    })
 
  });
  /* ## END READY ## */
}(algoliaShopify));

/* #5. */
(function (algolia) {
  'use strict';

  var _ = algolia._;

  var TYPES_TO_WIDGET = {
    slider: { name: 'rangeSlider', useDefault: true, params: {step:5} },
    menu: { name: 'menu', params: { limit: 100 } },
    conjunctive: { name: 'refinementList', params: { operator: 'and', limit: 100 } },
    disjunctive: { name: 'refinementList', params: { operator: 'or', limit: 100 } },
  };

  var sortByRefined = function sortByRefined (sortFunction) {
    return function (a, b) {
      if (a.refined !== b.refined) {
        if (a.refined) {
          return -1;
        }
        if (b.refined) {
          return 1;
        }
      }
      return sortFunction(a, b);
    };
  };

  algolia.facetSortFunctions = {
  };

  algolia.facetDisplayFunctions = {
    'named_tags.Stretch': function displayYesOrNo(stretchval) {
      if(stretchval == '0'){
        return algolia.translations.no;
      } else if(stretchval == '1'){
        return algolia.translations.yes;
      }
    }
  }

  algolia.facetCssClasses = {
    root: 'ais-facet',
    header: 'ais-facet--header',
    body: 'ais-facet--body',
    item: 'ais-facet--item',
    label: 'ais-facet--label',
    checkbox: 'ais-facet--checkbox',
    active: 'ais-facet--active',
    count: 'ais-facet--count'
  };

  // NEW LANGUAGE SETUP //
  var persistFacets = ['composition','grams','certificates','stretch','swatch'];
  var configLng = algolia.language+'__';
  var configdataFacets = algolia.config.facets;
  var confignewFacets = [];
  _.each(configdataFacets, function (facet) {
    var fct_pref = algolia.language;
    var fct_name = facet.name;
    var fct_name_clean = fct_name.toLowerCase().replace('named_tags.','');
    if(persistFacets.indexOf(fct_name_clean) >= 0){
      	confignewFacets.push(facet);
    } else if(fct_name_clean.indexOf(configLng) >= 0){
      	confignewFacets.push(facet);
    }
  });
  var enabledFacets = _.filter(confignewFacets, function (facet) { return facet.enabled || parseInt(facet.enabled); });

  algolia.facets = _.map(enabledFacets, function (facet) {
    return Object.assign({}, facet, { escapedName: encodeURIComponent(facet.name) }) 
  });
  algolia.shownFacets = _.filter(algolia.facets, function (facet) { return facet.type !== 'hidden' });
  algolia.hiddenFacets = _.filter(algolia.config.facets, function (facet) { return facet.type === 'hidden'; });
  algolia.facetTitles = {};
  _.each(algolia.facets, function (facet) {
    if(facet.title == 'Weight' || facet.title == 'Composition' || facet.title == 'Certificates' || facet.title == 'Swatch'){
      var factrkey = facet.title.toLowerCase();
      facet.title = algolia.translations[factrkey];
    }
    algolia.facetTitles[facet.name] = facet.title;
  });
  
  
  algolia.facetsWidgets = _.map(algolia.shownFacets, function (facet) {

    var widget = TYPES_TO_WIDGET[facet.type],
        params = _.cloneDeep(widget.params) || {};

    params.container = "[class~='ais-facet-" + facet.escapedName + "']";
    params.attributeName = facet.name;
    params.templates = {};
    params.cssClasses = algolia.facetCssClasses;

    if (facet.searchable) {
      params.searchForFacetValues = {placeholder: 'Search for ' + facet.name, isAlwaysActive: true};
      params.searchForFacetValues.templates = {noResults: '<div> No matching ' + facet.name + '</div>'};
    }

    params.templates.header = function () {
      return facet.title;
    }

    if (!widget.useDefault) {
      params.templates.item = algolia.getTemplate('instant_search_facet_item');
    }

    if (algolia.facetSortFunctions[facet.name]) {
      params.sortBy = algolia.facetSortFunctions[facet.name];
    }

    var displayFunction = algolia.facetDisplayFunctions[facet.name];
    params.transformData = function (data) {
      data.type = {};
      data.type[facet.type] = true;
      data.aisFacInd = facet.escapedName;
      if (displayFunction) {
        data.name = displayFunction(data.name);
      }
      return data;
    }
    
    return {
      name: widget.name,
      params: params
    };
  });
}(algoliaShopify));

/* #6. */
(function (algolia) {
  'use strict';
  var _ = algolia._;
  var sort_order_base = '' + algolia.config.index_prefix + 'products';
  algolia.sortOrders = [ { name: sort_order_base, label: '' + algolia.translations.sort_labels['default'] } ];

  _.forEach(algolia.config.sort_orders, function (sort_order) {
    if (!_.isUndefined(sort_order.asc) && !_.isNull(sort_order.asc) && (sort_order.asc.active === true || sort_order.asc.active === '1')) {
      algolia.sortOrders.push({ name: sort_order_base + '_' + sort_order.key + '_asc', label: algolia.translations.sort_labels[sort_order.key+'_asc'] });
    }
    if (!_.isUndefined(sort_order.desc) && !_.isNull(sort_order.desc) && (sort_order.desc.active === true || sort_order.desc.active === '1')) {
      
      algolia.sortOrders.push({ name: sort_order_base + '_' + sort_order.key + '_desc', label: algolia.translations.sort_labels[sort_order.key+'_desc'] });
    }
  });
}(algoliaShopify));

/* #7. */
(function (algolia, instantsearch) {
  var collectionFacetConstraint = !!algolia.is_collection_results_page &&
    !!algolia.config.instant_search_enabled_on_collection;
  if (
      (!algolia.full_results && !collectionFacetConstraint) || !algolia.config.instant_search_enabled
    ) {
    return;
  }

  var _ = algolia._,
      $ = algolia.jQuery;
  
  var algolia_IS_strip = ' NOT "product_type":"Sample" AND NOT "product_type":"Special" ';  
  if(!!cust_globspec_col && cust_globspec_col.length > 3){
    var algolia_IN_adj = cust_globspec_col;
    if(algolia_IN_adj.substring(0, 1) == 'c' ){
      algolia_IS_strip = ' ("named_tags.SpecialFor":"'+algolia_IN_adj+'" OR "product_type":"Fabric") ';
    }
  }
  /*if($('body').hasClass('agc__A4') == false){
    algolia_IS_strip += ' AND NOT "vendor":"HemmersItex" ';
    algolia_IS_strip += ' AND NOT "named_tags.Season":"T001" ';
    algolia_IS_strip += ' AND NOT "named_tags.Season":"T002" ';
  }*/
  
  // ADDING AVAIL FILTER //
  var algolia_Match_Avail = window.location.href;
  if(algolia_Match_Avail.indexOf('availf=roll') > -1){
    // rolls in stock //
    algolia_IS_strip += ' AND ("variant_title":"Rolls" AND "meta.availability.Availability":"1000")';
  } else if(algolia_Match_Avail.indexOf('availf=fold') > -1){
    // double folded in stock
    algolia_IS_strip += ' AND ("variant_title":"Double Folded" AND "meta.availability.Availability":"1000")';
  } else if(algolia_Match_Avail.indexOf('availf=smlp') > -1){
    // small piece in stock
    algolia_IS_strip += ' AND ("variant_title":"Small Piece" AND "meta.availability.Availability":"1000")';
  }

  var algolia_CollectionId = $('.algolia-shopify-instantsearch').attr('data-collectionid');

  var instant = algolia.instantsearch = {
    colors: algolia.config.colors,
    distinct: !!algolia.config.show_products,
    facets: {
      hidden: algolia.hiddenFacets,
      shown: algolia.shownFacets,
      list: algolia.facets,
      widgets: algolia.facetsWidgets
    },
    hitsPerPage: algolia.config.products_full_results_hits_per_page,
    poweredBy: algolia.config.powered_by,
    search: instantsearch({
      appId: algolia.config.app_id,
      apiKey: algolia.config.search_api_key,
      indexName: '' + algolia.config.index_prefix + 'products',
      searchParameters: {
        clickAnalytics: true,
        facetingAfterDistinct: true
      },
      urlSync: {},
      searchFunction: function (searchFunctionHelper) {
        var helper = instant.search.helper;
        var page = helper.getPage();
        if(page > 100){ // page137fix
          page = 0;
        }
        /* NEW INTENTION CORRECTION */
        var aisQbox = $('input.aa-input').val();
        var aisReQuery = intentionCorrection(aisQbox);
        helper.setQueryParameter('query', aisReQuery);
        if (instant.distinct) {
          helper.setQueryParameter('distinct', true);
        }
        if(algolia_CollectionId){
          helper.setQueryParameter('filters', '"collection_ids":"' + algolia_CollectionId + '" AND ' + algolia_IS_strip);
        } else {
           helper.setQueryParameter('filters', algolia_IS_strip);
        }
        if(typeof cust_glob_did == 'string' && typeof main_globlang == 'string'){
          if(cust_glob_did == ''){
              helper.setQueryParameter('userToken', main_globlang);
          } else {
              helper.setQueryParameter('userToken', cust_glob_did);
          }       
        }
        var suspiciousAisQuery =
        /\(tg:[a-z0-9]+\)/i.test(aisReQuery);
        if(!suspiciousAisQuery){
        //if(aisReQuery.indexOf('%pa') < 0 && aisReQuery.indexOf('%25pa') < 0){
          helper.setPage(page);
          searchFunctionHelper.search();
        }
      }
    }),
    selector: algolia.config.results_selector,
    sortOrders: algolia.sortOrders,
    storeName: algolia.storeName,
    templates: {
      currentItem: algolia.getTemplate('instant_search_current_refined_values_item'),
      empty: algolia.getTemplate('instant_search_no_result'),
      page: algolia.compileTemplate('instant_search'),
      product: algolia.getTemplate('instant_search_product'),
      stats: algolia.getTemplate('instant_search_stats')
    }
  };


  // Bind helpers
  _.forEach(Object.assign({}, algolia.helpers, algolia.translation_helpers), function (helper, name) {
    instant.search.templatesConfig.helpers[name] = helper;
  });
  instant.search.templatesConfig.compileOptions = algolia.hoganOptions;

  $(document).ready(function () {
    
    instant.$results = $(instant.selector);
    instant.$results.html(algolia.render(instant.templates.page, {
      facets: instant.facets.list,
      storeName: instant.storeName,
      translations: algolia.translations
    }));

    // Mobile facets display
    instant.search.addWidget({
      init: function (opts) {
        var $button = $('.ais-facets-button');
        $button.on('click', function () {
          var $facets = $('.ais-facets');
          if ($facets.hasClass('ais-facets__shown')) {
            $button.text(algolia.translations.showFilter);
            $facets.removeClass('ais-facets__shown');
            $('body').removeClass('ais-mobfacets__open');
          } else {
            $button.text(algolia.translations.hideFilter);
            $facets.addClass('ais-facets__shown');
            $('body').addClass('ais-mobfacets__open');
          }
        });
        $('.algolia-shopify-instantsearch').on('click', '.ais-current-refined-values--clear-all', function (e) {
          $button.text(algolia.translations.showFilter);
          $('.ais-facets').removeClass('ais-facets__shown');
          $('body').removeClass('ais-mobfacets__open');
        });
      }
    });

    // Stats
    instant.search.addWidget(
      instantsearch.widgets.stats({
        container: '.ais-stats-container',
        templates: {
          body: instant.templates.stats,
        },
        transformData: {
          body: function (data) {
            data.start = data.page * data.hitsPerPage + 1;
            data.end = Math.min((data.page + 1) * data.hitsPerPage, data.nbHits);
            return data;
          }
        }
      })
    );

    // Sort orders
    instant.search.addWidget(
      instantsearch.widgets.sortBySelector({
        container: '.ais-sort-orders-container',
        indices: instant.sortOrders
      })
    );

    // Hidden facets
    var list = _.map(instant.facets.hidden, function (facet) { return facet.name; });
    instant.search.addWidget({
      getConfiguration: function () {
        return {
          facets: list,
          disjunctiveFacets: list
        };
      },
      init: function () {}
    });

    // Current refined values
    var attributes = _.map(instant.facets.shown, function(facet) {
      var displayFunction = algolia.facetDisplayFunctions[facet.name];
      return {
        name: facet.name,
        label: facet.title,
        transformData: function (value) {
          value.aisFacInd = facet.escapedName;
          if (displayFunction) {
            value.name = displayFunction(value.name);
          }
          return value;
        }
      }
    });
    instant.search.addWidget(
      instantsearch.widgets.currentRefinedValues({
        container: '.ais-current-refined-values-container',
        cssClasses: {
          root: 'ais-facet',
          header: 'ais-facet--header',
          body: 'ais-facet--body'
        },
        templates: {
          header: algolia.translations.selectedFilter,
          item: instant.templates.currentItem,
          clearAll: algolia.translations.clearAll
        },
        onlyListedAttributes: true,
        attributes: attributes
      })
    );

    // Facets
    _.forEach(instant.facets.widgets, function (widget) {
      instant.search.addWidget(instantsearch.widgets[widget.name](widget.params));
    });

    // Hits
    instant.search.addWidget(
      instantsearch.widgets.hits({
        container: '.ais-hits-container',
        hitsPerPage: instant.hitsPerPage,
        templates: {
          empty: instant.templates.empty,
          item: instant.templates.product
        },
        transformData: {
          item: function (product) {
            product._distinct = instant.distinct;
            product._indx_used = instant.search.helper.lastResults._rawResults[0].index;
            product.translations = algolia.translations;
            product.queryID = instant.search.helper.lastResults._rawResults[0].queryID;
            product.productPosition = product.__hitIndex + 1;
            return product;
          },
          empty: function (params) {
            params.translations = algolia.translations;
            return params;
          }
        }
      })
    );

    // evHub + Stats Copy //
    instant.search.addWidget({
      render: function (opts) {
        $('.ais-stats-container-copy').html($('.ais-stats-container').html());
        if(instant.search.helper.lastResults._rawResults[0] && instant.search.helper.lastResults._rawResults[0].index){
            var currEVindx = instant.search.helper.lastResults._rawResults[0].index;
            var currEVqry = instant.search.helper.lastResults._rawResults[0].queryID;
            $('.algolia-shopify-instantsearch').attr('data-evhub-index', currEVindx);
            $('.algolia-shopify-instantsearch').attr('data-evhub-queryid', currEVqry);
        }
      }
    });

    // No result actions
    instant.search.addWidget({
      init: function (opts) {
        $('.ais-hits-container').on('click', '.ais-hit-empty--clear-filters', function () {
          var helper = opts.helper;
          helper.clearTags();
          _.forEach(instant.facets.list, function (facet) {
            helper.clearRefinements(facet.name);
          });
          helper.search();
        });
        $('.ais-hits-container').on('click', '.ais-hit-empty--clear-input', function () {
          opts.helper.setQuery('').search();
          $('.ais-search-box--input').val('').focus();
        });
      }
    });

    // Pagination
    instant.search.addWidget(
      instantsearch.widgets.pagination({
        container: '.ais-pagination-container',
        padding: 4,
        maxPages: 100,
        scrollTo: document.querySelector('.aisScrollTo')
      })
    );

    // Main
    instant.search.start();
  });
}(algoliaShopify, instantsearch));